import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CarsService {
  private readonly jsonHttpHeaders: HttpHeaders;
  private baseUrl = 'https://assurancezenith.com:99/cars-api/src/public';
  private urlMarques = this.baseUrl + '/cars/marques';
  private urlModels = this.baseUrl + '/cars/marque/models';
  private urlAlimentations = this.baseUrl + '/cars/marque/model/alimentations';
  private urlNombreChevaux = this.baseUrl + '/cars/marque/model/alimentation/chevaux';
  private urlCarrosseries = this.baseUrl + '/cars/marque/model/alimentation/chevaux/carrosseries';
  private urlVersions = this.baseUrl + '/cars/marque/model/alimentation/chevaux/carrosserie/versions';
  private urlCodeGta = this.baseUrl + '/cars/marque/model/alimentation/chevaux/carrosserie/versions/gta';
  private urlMarquePopularImages = this.baseUrl + '/images/';

  constructor(private http: HttpClient) {
    this.jsonHttpHeaders =  new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json');
  }
  public getUrlMarquePopularImages(): string {return this.urlMarquePopularImages; }
  public getMarquesByDateMEC(dateMEC: number): Observable<any> {
    const httpParams = new HttpParams().set('year', String(dateMEC));
    return this.http.get(this.urlMarques, {headers: this.jsonHttpHeaders, params: httpParams, responseType: 'json'});
  }
  public getModelsByDateMECAndMarque(dateMEC: number, marque: string): Observable<any> {
    const httpParams = new HttpParams()
      .set('year', String(dateMEC))
      .set('marque', marque);
    return this.http.get(this.urlModels, {headers: this.jsonHttpHeaders, params: httpParams, responseType: 'json'});
  }
  public getAlimentationsByDateMECAndMarqueAndModel(dateMEC: number, marque: string, model: string): Observable<any> {
    const httpParams = new HttpParams()
      .set('year', String(dateMEC))
      .set('marque', marque)
      .set('model', model);
    return this.http.get(this.urlAlimentations, {headers: this.jsonHttpHeaders, params: httpParams, responseType: 'json'});
  }
  public getChevauxByDateMECAndMarqueAndModelAndAlimentation(dateMEC: number, marque: string, model: string, alimentation: string)
    : Observable<any> {
    const httpParams = new HttpParams()
      .set('year', String(dateMEC))
      .set('marque', marque)
      .set('model', model)
      .set('alimentation', alimentation);
    return this.http.get(this.urlNombreChevaux, {headers: this.jsonHttpHeaders, params: httpParams, responseType: 'json'});
  }
  public getCarrosseriesByDateMECAndMarqueAndModelAndAlimentationAndChevaux(dateMEC: number, marque: string, model: string,
                                                                            alimentation: string, chevaux: number): Observable<any> {
    const httpParams = new HttpParams()
      .set('year', String(dateMEC))
      .set('marque', marque)
      .set('model', model)
      .set('alimentation', alimentation)
      .set('chevaux', String(chevaux));
    return this.http.get(this.urlCarrosseries, {headers: this.jsonHttpHeaders, params: httpParams, responseType: 'json'});
  }
  public getVersionsByDateMECAndMarqueAndModelAndAlimentationAndChevauxAndCarrosserie(dateMEC: number, marque: string, model: string,
                                                                                      alimentation: string, chevaux: number,
                                                                                      carrosserie: string)
    : Observable<any> {
    const httpParams = new HttpParams()
      .set('year', String(dateMEC))
      .set('marque', marque)
      .set('model', model)
      .set('alimentation', alimentation)
      .set('chevaux', String(chevaux))
      .set('carrosserie', carrosserie);
    return this.http.get(this.urlVersions, {headers: this.jsonHttpHeaders, params: httpParams, responseType: 'json'});
  }
  public getCodeGtaByDateMECAndMarqueAndModelAndAlimentationAndChevauxAndCarrosserieAndVersion(dateMEC: number, marque: string, model: string, alimentation: string,
                                                                                               chevaux: number, carrosserie: string, version: string)
    : Observable<any> {
    const httpParams = new HttpParams()
      .set('year', String(dateMEC))
      .set('marque', marque)
      .set('model', model)
      .set('alimentation', alimentation)
      .set('chevaux', String(chevaux))
      .set('carrosserie', carrosserie)
      .set('version', version);
    return this.http.get(this.urlCodeGta, {headers: this.jsonHttpHeaders, params: httpParams, responseType: 'json'});
  }
}
